/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/loupe_medium'
export default icon
